<template>
  <v-row align="center" dense>
    <v-col v-for="([key, value]) in Object.entries(detailItems)" :key="value.label" cols="auto" >
      <v-chip small outlined>
        <span v-if="key !== 'scaleDataSource'">
          <Icon margin="" iconColor="secondary" :icon="IconHelpers.getIconForObjectType(key)" :tooltipText="$t(key)"></Icon>
          {{ value }}
        </span>
        <span v-else>
          <Icon margin="" iconColor="secondary" :icon="getScaleDataSourceIcon(detailItems.scaleDataSource)" :tooltipText="getScaleDataSourceTooltip(detailItems.scaleDataSource)"></Icon>
          {{ getScaleDataSourceTooltip(detailItems.scaleDataSource) }}
        </span>
      </v-chip>
    </v-col>
  </v-row>
</template>

<script>
import { formatScaleDataInfo } from '@/components/ticket/ticket-details/scale-data/TicketScaleData'
import { ScaleDataSource } from '@/utils/Enumerations'
import IconHelpers from '@/utils/IconHelpers'

export default {
  name: 'TicketScaleDataInfoAsChips',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    scaleData: {
      type: Object,
      required: true
    },
    scaleDataSource: {
      type: Number,
      required: false,
      default: null
    },
    ext2: {
      type: String,
      required: false,
      default: null
    }
  },

  data () {
    return {
      IconHelpers
    }
  },

  computed: {
    detailItems () {
      return formatScaleDataInfo(this.scaleData, this.scaleDataSource, this.ext2)
    }
  },

  methods: {
    getScaleDataSourceIcon (scaleDataSource) {
      switch (scaleDataSource) {
        case ScaleDataSource.Scaled.value:
          return 'mdi-ruler-square'
        case ScaleDataSource.Expansion.value:
          return 'mdi-alpha-e-circle-outline'
        case ScaleDataSource.Imported.value:
          return 'mdi-file-import'
      }
    },
    getScaleDataSourceTooltip (scaleDataSource) {
      return ScaleDataSource.fromInt(scaleDataSource)
    }
  }
}
</script>
